import {get, set} from "lodash"

/**
 * @author: Richard Scoones
 * @description: Format the error before sending to sentry
 */
export default function dataCallback(data: any) {
  // Change message from "Request failed with status code XXX" to "Request failed with error code YYY"
  const errorCode = get(data, "extra.error.response.code", "")
  if (errorCode) {
    const errorString = `Request failed with error code: ${errorCode}`
    set(data, "exception.values[0].value", errorString)
  }

  return data
}
